import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const Container = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  outline: none;
  width: 100%;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }

  border: none;
  border-bottom: 1px solid #dbdbdb;
  background-color: transparent;
  padding: 0 2px;
  border-radius: 0 !important;
  
  &:first-child {
    border-top: 1px solid #dbdbdb;
  }
`;

const Title = styled.p`
  all: initial;
  display: block;
  padding: 20px 0;
  cursor: pointer;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const Drawer = ({ link }) => {
  const history = useHistory();

  const identifyTarget = () => {
    if ('sphere' in link && link.sphere === 'remote') {
      const isDepoList = link.href.includes('drop-depot-list');
      const isDropEvent = link.href.includes('event');

      if (isDepoList) {
        const id = link.href.substr(27, link.href.length);
        history.push('/depo-list', { id, type: 'depo-list' });
      }

      if (isDropEvent) {
        const id = link.href.substr(27, link.href.length);
        history.push('/event-list', { id, type: 'event-list' });
      }
    } else if ('type' in link && link.type === 'remote') {
      if (link.hrefPart === 'search.page') {
        // Go to WGW page
        history.push('/');
      } else if (link.hrefPart.includes('gpg')) {
        // Go to General page
        history.push('/general-page', { link: link.hrefPart, title: link.drawer_title });
      } else if (link.hrefPart.includes('drop-depot')) {
        // Go to Depo details page
        const id = link.hrefPart.substring(11, link.hrefPart.length - 5);
        history.push('/depo-details', { depoId: id, type: 'depo-details' });
      } else if (link.hrefPart.includes('material')) {
        // Go to Material details page
        const materialId = link.hrefPart.replace('material/', '').replace('.page', '');
        history.push('/material-details', { materialId });
      } else {
        // Go to General Page
        history.push('/general-page', { link: link.hrefPart, title: link.drawer_title });
      }
    } else if (
      'type' in link && link.type === 'external'
    ) {
      // Open External page
      window.open(link.href);
    } else if (
      'type' in link && link.type === 'remote'
    ) {
      // Go to General page
      history.push('/general-page', { link: link.hrefPart, title: link.drawer_title });
    }
  };

  const { drawer_title } = link;
  return (
    <Container tabIndex="0" onClick={identifyTarget} aria-label={drawer_title}>
      <Title tabIndex="-1">
        {drawer_title}
      </Title>
    </Container>
  );
};

export default Drawer;
